import type { SemanticColor } from '@atlaskit/lozenge';

const getStatusAppearanceFromKey = (key?: string | null): SemanticColor => {
	switch (key) {
		case 'off_track':
		case 'red':
			return 'danger';
		case 'at_risk':
		case 'yellow':
			return 'warning';
		case 'on_track':
		case 'green':
			return 'success';
		case 'completed':
		case 'paused':
		case 'pending':
		default:
			return 'neutral';
	}
};

interface FocusAresStatusInfo {
	statusKey: string | undefined | null;
	statusDisplayName: string | undefined | null;

	healthKey: string | undefined | null;
	healthDisplayName: string | undefined | null;
	healthColor: string | undefined | null;
}

export const getDisplayedFocusAreaStatus: ({
	healthColor,
	healthDisplayName,
	healthKey,
	statusDisplayName,
	statusKey,
}: FocusAresStatusInfo) => {
	displayedStatus: string | null | undefined;
	displayedStatusAppearance: SemanticColor;
} = ({
	healthColor,
	healthDisplayName,
	healthKey,
	statusDisplayName,
	statusKey,
}: FocusAresStatusInfo) => {
	const displayedStatus = statusKey === 'in_progress' ? healthDisplayName : statusDisplayName;
	const displayedStatusAppearance = getStatusAppearanceFromKey(
		healthColor?.toLowerCase() || healthKey || statusKey,
	);

	return { displayedStatus, displayedStatusAppearance };
};
